import { useEffect, useState } from "react";
import { GET_ALL_NEWS, fetchData } from "../../../components/Service";
import OwlCarousel from "react-owl-carousel";
import { Link } from "../../../../node_modules/react-router-dom/dist/index";

const News = () => {
	const [news, setNews] = useState([]);

	const getNews = () => {
		fetchData(GET_ALL_NEWS, "GET", "", false, false, (res) => {
			if (res.status) {
				setNews(res?.data?.data);
			} else {
				console.log(res);
			}
		});
	};

	useEffect(() => {
		getNews();
	}, []);
	return (
		<>
			{news && news.length > 0 && (
				<div className="card">
					<div className="card-header d-flex align-items-center justify-content-between mb-0 usa-bg py-1">
						<div className="national-bg">
							<h6 className="text-white d-flex ind1">News & Articles</h6>
						</div>
						<Link to={`/news-articles`} className="text-white align-middle font13 d-flex align-items-center position-relative ">
							View <i className="fi fi-rr-arrow-small-right text-white linehight0 ms-1"></i>
						</Link>
					</div>
					<div className="card-body p-1">
						<div className="row d-flex align-items-center">
							<div className="col-md-12 dotnavhide">
								<OwlCarousel
									className="owl-carousel"
									video={true}
									videoHeight={150}
									videoWidth={true}
									items={4}
									loop={true}
									margin={10}
									nav={true}
									autoplay={true}
									autoplayTimeout={2000}
									responsive={{
										0: {
											items: 3,
										},
										600: {
											items: 4,
										},
									}}
								>
									{news?.map((item) => (
										<div key={item.id} className="item-video">
											<a className="owl-video" href={item.video_link}></a>
										</div>
									))}
								</OwlCarousel>
							</div>
						</div>
					</div>
				</div>
			)}
		</>
	);
};

export default News;
